import React from "react";

// Premium cyberpunk/gothic demonic eye emblem
export default function DemonEye({ size = 64, className = "" }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 120 120"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <radialGradient id="iris" cx="50%" cy="50%" r="50%">
          <stop offset="0%" stopColor="#f5d0fe" />
          <stop offset="35%" stopColor="#a855f7" />
          <stop offset="75%" stopColor="#6d28d9" />
          <stop offset="100%" stopColor="#1e0b3b" />
        </radialGradient>
        <linearGradient id="ring" x1="0" y1="0" x2="120" y2="120">
          <stop offset="0%" stopColor="#e2e8f0" />
          <stop offset="50%" stopColor="#a855f7" />
          <stop offset="100%" stopColor="#f59e0b" />
        </linearGradient>
        <filter id="glow" x="-50%" y="-50%" width="200%" height="200%">
          <feGaussianBlur stdDeviation="2.4" result="b" />
          <feMerge>
            <feMergeNode in="b" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
      </defs>

      {/* outer arcs */}
      <path d="M8 60 Q60 4 112 60" stroke="url(#ring)" strokeWidth="2.5" fill="none" filter="url(#glow)" />
      <path d="M8 60 Q60 116 112 60" stroke="url(#ring)" strokeWidth="2.5" fill="none" filter="url(#glow)" />

      {/* eye almond */}
      <path
        d="M18 60 Q60 22 102 60 Q60 98 18 60 Z"
        fill="#0a0513"
        stroke="#a855f7"
        strokeWidth="1.6"
        opacity="0.95"
      />

      {/* iris */}
      <circle cx="60" cy="60" r="24" fill="url(#iris)" filter="url(#glow)" />
      {/* slit pupil */}
      <ellipse cx="60" cy="60" rx="5" ry="20" fill="#08040f" />
      <ellipse cx="60" cy="60" rx="5" ry="20" fill="none" stroke="#f59e0b" strokeWidth="0.8" opacity="0.7" />
      {/* highlight */}
      <circle cx="52" cy="50" r="4" fill="#ffffff" opacity="0.85" />

      {/* iris tick marks */}
      {Array.from({ length: 24 }).map((_, i) => {
        const a = (i / 24) * Math.PI * 2;
        const x1 = 60 + Math.cos(a) * 26;
        const y1 = 60 + Math.sin(a) * 26;
        const x2 = 60 + Math.cos(a) * 30;
        const y2 = 60 + Math.sin(a) * 30;
        return <line key={i} x1={x1} y1={y1} x2={x2} y2={y2} stroke="#a855f7" strokeWidth="1" opacity="0.6" />;
      })}

      {/* lower lashes / gothic spikes */}
      {[-30, -15, 0, 15, 30].map((dx, i) => (
        <path
          key={i}
          d={`M${60 + dx} 92 l${dx / 6} 12`}
          stroke="url(#ring)"
          strokeWidth="1.6"
          opacity="0.8"
          filter="url(#glow)"
        />
      ))}
    </svg>
  );
}
